import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'

interface ErrorBlockProps {
    error: string
}

const ErrorBlock: React.FC<ErrorBlockProps> = ({ error }) => (
    <Stack
        sx={{
            backgroundColor: 'error.main',
            p: 1.5,
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '6px !important',
        }}
    >
        <Typography color="error.contrastText" fontWeight={700} variant="body2">
            {error}
        </Typography>
    </Stack>
)

export default ErrorBlock
